let account = localStorage.getItem('admin')

if (account) {
    account = JSON.parse(account)
}

export default account